import * as motion from "motion/react-client";
import {
  appearanceAnimation,
  slideLeftAnimation
} from "../../../utils/animations";

import vectorBg from "../../../assets/home/vectors-bg.png";
import { useTranslation } from "react-i18next";

const ReasonSection = () => {
  const { t } = useTranslation();

  return (
    <div className="relative w-full flex justify-center items-center md:px-6 pt-56 py-36 overflow-hidden">
      <div className="absolute top-24 -z-10">
        <img src={vectorBg} alt="bgImg" />
      </div>

      <div className="w-full max-w-[1290px] flex flex-col gap-28 justify-center items-center">
        {/* Title */}
        <div className="flex justify-center items-center w-[50%]">
          <motion.p
            {...appearanceAnimation("bottom")}
            className="text-[#074799] md:text-5xl text-3xl font-bold text-center md:leading-tight"
          >
            {t("home.why_choose_us")}
          </motion.p>
        </div>

        <div className="w-full grid lg:grid-cols-3 grid-cols-1 gap-8">
          {/* Card 1 */}
          <motion.div
            {...slideLeftAnimation(0)}
            className="p-8 flex flex-col gap-6 rounded-2xl w-full bg-white text-[#074799] hover:-translate-y-3 cursor-pointer hover:shadow-xl duration-300"
          >
            <p className="text-[50px] font-bold text-transparent custom-text-stroke">
              01
            </p>

            <p className="lg:text-[22px] md:text-lg text-base font-bold">
              {t("home.why_choose_us.reason1")}
            </p>

            <p className="md:text-base text-sm">
              {t("home.why_choose_us.reason1.description")}
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div
            {...slideLeftAnimation(1)}
            className="p-8 flex flex-col gap-6 rounded-2xl w-full bg-white text-[#074799] hover:-translate-y-3 lg:mt-10 cursor-pointer hover:shadow-xl duration-300"
          >
            <p className="text-[50px] font-bold text-transparent custom-text-stroke">
              02
            </p>

            <p className="lg:text-[22px] md:text-lg text-base font-bold">
              {t("home.why_choose_us.reason2")}
            </p>

            <p className="md:text-base text-sm">
              {t("home.why_choose_us.reason2.description")}
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div
            {...slideLeftAnimation(2)}
            className="p-8 flex flex-col gap-6 rounded-2xl w-full bg-white text-[#074799] hover:-translate-y-3 cursor-pointer hover:shadow-xl duration-300"
          >
            <p className="text-[50px] font-bold text-transparent custom-text-stroke">
              03
            </p>

            <p className="lg:text-[22px] md:text-lg text-base font-bold">
              {t("home.why_choose_us.reason3")}
            </p>

            <p className="md:text-base text-sm">
              {t("home.why_choose_us.reason3.description")}
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ReasonSection;
